import gsap from 'gsap'
import { debounce } from './utilities'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { pxToRem } from './utilities'
import { lenis } from './lenis'

gsap.registerPlugin(ScrollTrigger)

gsap.config({
  // nullTargetWarn: false
})

export let initAnimations, Banner, Features, Flags, LargeText, PageHeader, PageHeaderTicker, ContentBlock, Articles, Article, TextImage, Contact

Banner = () => {
	const banner = document.querySelector('.banner')

	if (!banner || window.isLivePreview) return 

	const header = document.querySelector('.header__inner')
	const lines = banner.querySelectorAll('.line')
	const text = banner.querySelector('.banner__text')
	const image = banner.querySelector('.banner__image img')
	// const assets = banner?.querySelectorAll('.banner__ui')
	const assets = banner.querySelectorAll('.banner__animation')
	const videos = banner.querySelectorAll('.banner__animation video')
	const button = banner.querySelector('.banner__button')
	
	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	if (window.initialLoad) {
		header.classList.add('reduced')
	}

	tl.fromTo(lines, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	})
	tl.fromTo([text, button], {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.4')
	tl.fromTo(image, {
		scale: 1.2,
		opacity: 0,
		filter: 'blur(6px)',
	}, {
		scale: 1,
		opacity: 1,
		filter: 'blur(0px)',
		duration: 1.8,
		ease: 'power2.inOut',
	}, '-=1.4')
	tl.fromTo(assets, {
		scale: 0.7,
		opacity: 0,
		filter: 'blur(12px)',
	}, {
		scale: 1,
		opacity: 1,
		filter: 'blur(0px)',
		stagger: 0.15,
		duration: 2,
		ease: 'power3.out',
	}, '-=1.2')
	tl.add(() => {
		if (window.innerWidth <= 650) {
			setTimeout(() => videos[0].play(), 0)
			setTimeout(() => videos[2].play(), 200)
		} else {
			setTimeout(() => videos[0].play(), 0)
			setTimeout(() => videos[1].play(), 250)
			setTimeout(() => videos[2].play(), 500)
		}
	}, '-=2')
	if (window.initialLoad) {
		tl.fromTo(header, {
			scale: 0
		}, {
			scale: 1,
			duration: 0.6,
			ease: 'back.out(1.4)',
			clearProps: 'all'
		}, '-=1.4')
		tl.add(() => {
			header.classList.remove('reduced')
		}, '-=0.6')
	}
}

Flags = () => {
	const els = document.querySelectorAll('.places__flags')
	
	if (!els.length) return

	els.forEach(el => {
		const track = el.querySelector('.places__flags-track')
		const trackInner = el.querySelectorAll('.places__flags-track-inner')

		const animation = gsap.to(track, {
			repeat: -1,
			xPercent: -80,
			duration: 120,
			ease: 'linear'
		}).totalProgress(0.5)

		animation.seek(1000)

		lenis.on('scroll', () => {
			if (lenis.direction == -1) {
				animation.reverse()
			} else if (lenis.direction == 1) {
				animation.play()
			}
		})

		if (!trackInner) return

		gsap.to(trackInner, {
			scrollTrigger: {
				trigger: el,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true
			},
			xPercent: -25,
			ease: 'none'
		})

	})
}

LargeText = () => {
	const els = document.querySelectorAll('.text-block')

	if (!els.length) return

	els.forEach(el => {
		const lines = el?.querySelectorAll('.line')
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 60%',
				end: 'bottom 20%',
				scrub: 0.75
			}
		})
		tl.fromTo(lines, {
			yPercent: 108
		}, {
			yPercent: 0,
			duration: 1.6,
			stagger: 0.1,
			ease: 'expo',
		})
	})
}

PageHeader = () => {
	const banner = document.querySelector('.banner-page')

	if (!banner || window.isLivePreview) return

	const tagline = banner?.querySelector('.banner-page__tagline')
	const lines = banner?.querySelectorAll('.line')
	const text = banner?.querySelector('.banner-page__text')
	const images = banner?.querySelector('.banner-page__text-media')
	const media = banner?.querySelectorAll('.banner-page__video, .banner-page__image')
	const sections = document.querySelectorAll('.banner-page ~ section, .banner-page ~ .pin-spacer')

	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	tl.fromTo(tagline, {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	})
	tl.fromTo(lines, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	}, '-=0.8')
	tl.fromTo(text, {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.2')

	if (media.length) {
		tl.fromTo(media, {
			scale: 1.2,
			opacity: 0,
			filter: 'blur(6px)',
		}, {
			scale: 1,
			opacity: 1,
			filter: 'blur(0px)',
			duration: 2,
			ease: 'power2.out',
		}, '-=0.85')
	}

	if (images) {
		tl.from(images, {
			width: 0,
			margin: 0,
			duration: 1,
			ease: 'power2.inOut'
		}, '-=1.4')
	}

	tl.fromTo(sections, {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.2')
}

PageHeaderTicker = () => {
	let animation
	let ticker = document.querySelector('.banner-page__ticker')
	
	if (!ticker) return

	function runAnimation() {
		ticker = document.querySelector('.banner-page__ticker')
		const tickerLines = ticker?.querySelectorAll('.ln')
		animation = gsap.timeline({ repeat: -1 })

		tickerLines.forEach((line, i) => {
			if (i == 0) {
				animation.to(tickerLines, { duration: 1.2, y: `-${i}00%`, ease: 'power3.inOut' })
			} else {
				animation.to(tickerLines, { duration: 1.2, y: `-${i}00%`, ease: 'power3.inOut' }, '+=1.0')
			}
		})
	}

	runAnimation()

	let windowWidth = window.innerWidth

	const handleResize = () => {
		if (windowWidth != window.innerWidth) {
			animation.kill()
			setTimeout(() => runAnimation(), 250)
		}
	}

	const debouncedResize = debounce(handleResize, 300)
	window.addEventListener('resize', debouncedResize)
}

ContentBlock = () => {
	const els = document.querySelectorAll('.content-block')

	if (!els.length) return

	els.forEach(el => {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 80%',
				once: true
			}
		})

		const lines = el.querySelectorAll('.line')
		const assets = el.querySelector('.content-block__assets')
		const body = el.querySelector('.content-block__body')

		tl.fromTo(lines, {
			yPercent: 108
		}, {
			yPercent: 0,
			duration: 1.6,
			stagger: 0.1,
			ease: 'expo',
		})
		tl.fromTo([assets, body], {
			y: 40,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 1,
			stagger: 0.1,
			ease: 'power2',
			clearProps: 'all'
		}, '-=1.4')
		
	})
}

Article = () => {
	const article = document.querySelector('.article')

	if (!article || window.isLivePreview) return
	
	const tagline = article?.querySelector('.article__category')
	const lines = article?.querySelectorAll('.article__heading .line')
	const text = article?.querySelector('.article__excerpt')
	const meta = article?.querySelectorAll('.article__meta')
	const image = article?.querySelectorAll('.article__image img')

	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	tl.fromTo(tagline, {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	})
	tl.fromTo(lines, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	}, '-=0.8')
	tl.fromTo([text, meta], {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.4')
	tl.fromTo(image, {
		scale: 1.2,
		opacity: 0,
		filter: 'blur(6px)',
	}, {
		scale: 1,
		opacity: 1,
		filter: 'blur(0px)',
		duration: 2,
		ease: 'power2.out',
	}, '-=1')
}

Articles = () => {
	const el = document.querySelector('.articles')

	if (!el) return

	const items = el.querySelectorAll('.articles__item')
	const lines = el?.querySelectorAll('.line')
	const bar = el.querySelector('.articles__bar')

	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	tl.fromTo(lines, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	})

	tl.fromTo(items, {
		y: 60,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.4')

	tl.fromTo(bar, {
		yPercent: 200,
		scale: 0.9
	}, {
		yPercent: 0,
		scale: 1,
		duration: 0.8,
		ease: 'power2',
	}, '-=1.4')
}

TextImage = () => {
	const els = document.querySelectorAll('.text-image')

	if (!els.length) return
	
	els.forEach(el => {
		const tagline = el.querySelector('.text-image__tagline')
		const lines = el.querySelectorAll('.text-image__text .line')
		const image = el.querySelector('.text-image__image img')

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 70%',
				once: true
			}
		})

		tl.fromTo(tagline, {
			y: 40,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 1,
			stagger: 0.1,
			ease: 'power2',
			clearProps: 'all'
		})

		tl.fromTo(lines, {
			yPercent: 108
		}, {
			yPercent: 0,
			duration: 1.6,
			stagger: 0.1,
			ease: 'expo',
		}, '-=0.5')

		tl.fromTo(image, {
			scale: 1.2,
			opacity: 0,
			filter: 'blur(6px)',
		}, {
			scale: 1,
			opacity: 1,
			filter: 'blur(0px)',
			duration: 1.8,
			ease: 'power2.inOut',
		}, '-=2')
	})
}

Contact = () => {
	const el = document.querySelector('.contact')

	if (!el) return

	const tagline = el.querySelector('.contact__tagline')
	const lines = el?.querySelectorAll('.line')
	const button = el.querySelector('.contact__button')
	const form = el.querySelector('.fui-i')

	const tl = gsap.timeline({
		delay: window.initialLoad ? 1 : 0
	})

	tl.fromTo(tagline, {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	})
	tl.fromTo(lines, {
		yPercent: 108
	}, {
		yPercent: 0,
		duration: 1.6,
		stagger: 0.1,
		ease: 'expo',
	}, '-=0.8')
	tl.fromTo([button, form], {
		y: 40,
		opacity: 0
	}, {
		y: 0,
		opacity: 1,
		duration: 1,
		stagger: 0.1,
		ease: 'power2',
		clearProps: 'all'
	}, '-=1.4')
}

initAnimations = () => {
	Banner()
	LargeText()
	PageHeader()
	PageHeaderTicker()
	ContentBlock()
	Article()
	Articles()
	TextImage()
	Contact()
}

export default () => {}